import { createSlice } from '@reduxjs/toolkit';

const TOKEN_KEY = 'pulseloop.token';

const initialState = {
  user: null,
  token: localStorage.getItem(TOKEN_KEY),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action) {
      const { user, token } = action.payload;
      if (user !== undefined) state.user = user;
      if (token !== undefined) {
        state.token = token;
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
      }
    },
    logout(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem(TOKEN_KEY);
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentRole = (state) => state.auth.user?.role ?? null;
export const selectCurrentOrganizationId = (state) =>
  state.auth.user?.organization_id ?? null;
export const selectToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => Boolean(state.auth.token);

export default authSlice.reducer;
